export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14813.b9367991.jpg";